var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hp-10 relative" }, [
    _c("div", {
      ref: "map",
      staticClass: "flex",
      staticStyle: { border: "1px solid #dedede", height: "100%" },
      attrs: { id: "map" }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "leaflet-touch map-additional-control" },
      [
        _vm.canFilter.length
          ? _c(
              "div",
              { staticClass: "leaflet-bottom leaflet-left" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "leaflet-bar leaflet-control p-2 white-bkg",
                    attrs: { value: _vm.checkedFilter }
                  },
                  [
                    _c(
                      "ul",
                      _vm._l(_vm.filters, function(filter) {
                        return _c(
                          "li",
                          { key: filter.id },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticClass: "py-1 flex-level",
                                attrs: {
                                  label: filter.id,
                                  disabled: !_vm.hasType(filter.id)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.filterMarkers($event, filter.id)
                                  }
                                }
                              },
                              [
                                _c("SaasIcon", {
                                  staticClass: "mr-1",
                                  class: "" + filter.bgcolor,
                                  attrs: {
                                    icon: "svgMarkerMap",
                                    width: 7,
                                    height: 11
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(filter.label))])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.currentPage > 0 && _vm.lastPage > 1 && !_vm.allMarkersLoaded
            ? _c(
                "div",
                { staticClass: "leaflet-top leaflet-center marker-loader" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "leaflet-bar leaflet-control p-2 white-bkg flex-level jc-space"
                    },
                    [
                      _c("div", { staticClass: "marker-loader-icon" }, [
                        _vm.percentage < 100
                          ? _c("span", {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: true,
                                  expression: "true"
                                }
                              ]
                            })
                          : _c("i", {
                              staticClass: "el-icon-circle-check success-50"
                            })
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "percentage" }, [
                        _vm._v(_vm._s(_vm.percentage) + " %")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }